import axios from 'axios'

export default function install(Vue,axiosOptions) {

  const axiosIntance = axios.create(axiosOptions);

  Vue.axios = axiosIntance;
  // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty
  Object.defineProperty(Vue.prototype, '$axios', {
    get() {
      return axiosIntance
    },
  })
}
